import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SelectHireMachinePage } from './select-hire-machine';

@NgModule({
  declarations: [
    SelectHireMachinePage,
  ],
  imports: [
    IonicPageModule.forChild(SelectHireMachinePage),
  ],
})
export class SelectHireMachinePageModule {}



// WEBPACK FOOTER //
// ./src/pages/select-hire-machine/select-hire-machine.module.ts